import { lazy } from 'react';

export const PlayerSourceOfFundsForm = lazy(
  () => import('./PlayerSourceOfFundsForm'),
);
